module.exports = __webpack_public_path__ + "static/media/banner-logo.0693ebf5.svg";